import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Custom toggle button with a checbox icon next to the name
 */
@Component({
    selector: 'app-custom-btn',
    templateUrl: './custom-btn.component.html',
    styleUrls: ['./custom-btn.component.scss'],
    standalone: false
})
export class CustomBtnComponent {
    /**
     * The name to show on the button
     */
    @Input() name!: string;
    /**
     * Whether the button is active
     */
    @Input() active = false;
    /**
     * Whether the button is disabled
     */
    @Input() disabled = false;
    /**
     * Emitted when the button is toggled
     */
    @Output() activeChange = new EventEmitter<boolean>();

    toggle(): void {
        if (!this.disabled) {
            this.activeChange.emit(this.active);
        }
    }
}
